import { make_temporary_pricing_id } from './entityIdFromName';

/**
 * Tickettype create often submits empty `pricings`. Seed one pricing named
 * after the tickettype so edit opens with a ready, expandable card.
 */
export function seed_first_tickettype_pricing(tickettype, {
    currency = 'CHF',
    vat = 0,
    idiv = 0,
    initialPricing,
} = {}) {
    if (!tickettype || typeof tickettype !== 'object')
        return tickettype;
    const existing = tickettype.pricings;
    if (existing && typeof existing === 'object' && !Array.isArray(existing)
        && Object.keys(existing).length > 0)
        return tickettype;
    if (typeof initialPricing !== 'function')
        return tickettype;
    const names = tickettype.name && typeof tickettype.name === 'object'
        ? { ...tickettype.name }
        : {};
    return {
        ...tickettype,
        pricings: {
            [make_temporary_pricing_id()]: initialPricing(names, currency, vat, 1, idiv),
        },
    };
}
